export default "__VITE_PUBLIC_ASSET__61e515d3__"